<div class="row wrp-reminders">
    <div [ngClass]="{'col-sm-12': true, 'no-padding': true, 'col-md-6': employeesInactive > 0, 'hidden': employeesUninvited === 0}">
        <div class="colabs-manager-reminder">
            <div class="wrp-icon">
            <img src="../../../assets/shared/img/icon-reminder.png">
            </div>
            <div class="wrp-text">
                <h3>{{ 'COMPANY.MANAGER.COLABS.REMINDERS.INVITATIONS_UNSENT.TITLE' | translate }}</h3>
                <p>{{ 'COMPANY.MANAGER.COLABS.REMINDERS.INVITATIONS_UNSENT.TEXT1' | translate }}
                    <strong>{{ 'COMPANY.MANAGER.COLABS.REMINDERS.INVITATIONS_UNSENT.NUM_UNINVITED_EMPLOYEES' | translate:{employeesUninvited: employeesUninvited} }}</strong>
                    {{ 'COMPANY.MANAGER.COLABS.REMINDERS.INVITATIONS_UNSENT.TEXT2' | translate }}
                    <a (click)="sendInvitationToUninvited()" *ngIf="employeesUninvited > 0 && canSendEmails()" title="">{{ 'COMPANY.MANAGER.COLABS.REMINDERS.INVITATIONS_UNSENT.TEXT_LINK' | translate }} <i class="fa fa-angle-right" aria-hidden="true"></i></a>
                    <a tooltip="O envio de convites em massa é limitado em 1 envio a cada 3 horas. Por favor, tente novamente mais tarde!" placement="bottom" show-delay="50" tooltip-class="tooltip-inner" class="soft-disabled" *ngIf="employeesUninvited > 0 && !canSendEmails()"> {{ 'COMPANY.MANAGER.COLABS.REMINDERS.INVITATIONS_UNSENT.TEXT_LINK' | translate }} <i class="fa fa-angle-right" aria-hidden="true"></i></a>
                </p>
            </div>
        </div>
    </div>
</div>


<div class="colab-manager-content-component fade-in-animation">
    <app-colabs-filter-form
        class="content-with-padding"
        [isActionButtonsBlocked]="isActionButtonsBlocked"
        (fetchRowsEvent)="fetchRows($event)"
        (sendInvitationToSelected)="sendInvitationToSelected($event)"
        (unlockSelected)="unlockSelected()"
        (blockSelected)="blockSelected()"
        [costCenters]="costCenters"
        [rowsCount]="rowsCount">
    </app-colabs-filter-form>

    <div class="clearfix"></div>

    <!-- Actions Buttons -->
    <div class="col-md-12 col-sm-12 actions-buttons" *ngIf="rowsCount > 0">
        <button [disabled]="this.colabsTable.isLoading" *ngIf="canSendEmails()" class="btn btn-orange" (click)="sendInvitationToSelected(true)"
          [tooltip]="'COMPANY.MANAGER.COLABS.ACTIONS_BUTTONS.TOOLTIPS.INVITE_ALL' | translate" placement="bottom" show-delay="100">{{ 'COMPANY.MANAGER.COLABS.ACTIONS_BUTTONS.INVITE_ALL' | translate }}</button>
        <button [disabled]="this.colabsTable.isLoading" *ngIf="canSendEmails()" class="btn btn-orange" (click)="sendInvitationAgain()"
          [tooltip]="'COMPANY.MANAGER.COLABS.ACTIONS_BUTTONS.TOOLTIPS.INVITE_AGAIN' | translate" placement="bottom" show-delay="100">{{ 'COMPANY.MANAGER.COLABS.ACTIONS_BUTTONS.INVITE_AGAIN' | translate }}</button>
        <button [disabled]="this.colabsTable.isLoading" *ngIf="!canSendEmails()" tooltip="O envio de convites em massa é limitado em 1 envio a cada 3 horas. Por favor, tente novamente mais tarde!" placement="bottom" tooltip-class="tooltip-inner" class="soft-disabled btn btn-orange">{{ 'COMPANY.MANAGER.COLABS.ACTIONS_BUTTONS.INVITE_ALL' | translate }}</button>
        <button [disabled]="this.colabsTable.isLoading" *ngIf="!canSendEmails()" tooltip="O envio de convites em massa é limitado em 1 envio a cada 3 horas. Por favor, tente novamente mais tarde!" placement="bottom" tooltip-class="tooltip-inner" class="soft-disabled btn btn-orange">Reenviar convites</button>
        <button [disabled]="!haveEmailSelected || this.colabsTable.isLoading" [ngClass]="{'btn': true, 'btn-orange': !isActionButtonsBlocked}" (click)="sendInvitationToSelected(false)">{{ 'COMPANY.MANAGER.COLABS.ACTIONS_BUTTONS.SEND_INVITATION' | translate }}</button>
        <button [disabled]="isActionButtonsBlocked || this.colabsTable.isLoading" [ngClass]="{'btn': true, 'btn-orange': !isActionButtonsBlocked}" (click)="unlockSelected($event)">{{ 'COMPANY.MANAGER.COLABS.ACTIONS_BUTTONS.UNLOCK_ACCESS' | translate }}</button>
        <button [disabled]="isActionButtonsBlocked || this.colabsTable.isLoading" [ngClass]="{'btn': true, 'btn-orange': !isActionButtonsBlocked}" (click)="blockSelected($event)">{{ 'COMPANY.MANAGER.COLABS.ACTIONS_BUTTONS.BLOCK_ACCESS' | translate }}</button>
        <button [disabled]="isActionButtonsBlocked || this.colabsTable.isLoading" [ngClass]="{'btn': true, 'btn-orange': !isActionButtonsBlocked}" (click)="openGroupModal()">{{ 'COMPANY.MANAGER.COLABS.ACTIONS_BUTTONS.CHANGE_GROUP' | translate }}</button>
    </div>
    <!-- End Actions Buttons -->

    <div class="clearfix"></div>

    <app-colabs-table
        (rowsCountEvent)="setRowsCount($event)"
        (unblockButtons)="onUnblockButtons($event)"
        (countUnivited)="setCountUnivited($event)"
        (countInactive)="setCountInactive($event)"
        (closeModalGroup)="closeGroupModal()"
        (haveEmail)="haveEmployeesWithEmailSelected($event)">
    </app-colabs-table>

    <app-colabs-modal-change-group
      #modalChangeAccountGroup
      (saveGroupChange)="saveChange($event)"
      [costCenters]="costCenters">
    </app-colabs-modal-change-group>
</div>
